import styled from 'styled-components';
import { CargoTempCategory } from '../../../types/ViewModel/CargoTempLog/CargoInTankItem';
import theme from 'src/theme';
import { MainButton } from 'src/styles/button.style';

type CategoryProps = {
    categoryType: CargoTempCategory;
};

export const Wrapper = styled.div``;

export const CargoesListWrapper = styled.div`
    overflow-y: auto;
    margin-bottom: 15px;
`;

export const CargoTemperatureRow = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
`;

export const CargoTankWrapper = styled.div`
    margin-bottom: 0.5rem;
`;

export const TankWrapper = styled.div`
    display: flex;
    margin-bottom: 0.5rem;
`;

export const TimeRowContainer = styled.div`
    margin-left: 1rem;
`;

export const OuterContentWrapper = styled.div`
    padding: 1rem 0;
`;

export const ContentWrapper = styled.div`
    padding-bottom: 5px;
`;

export const ConfigRow = styled.div`
    ${(props) => props.theme.inlineGridWrapper}
`;

export const SettingsSection = styled.div`
    display: flex;
    justify-content: flex-start;
    grid-gap: 10rem;
    border: 1px solid #ddd;
    padding: 0.5rem;
    margin: 10px;
    border-radius: 4px;
`;

const getCategoryColor = (category: CargoTempCategory) => {
    switch (category) {
        case CargoTempCategory.Inhibited:
            return theme.legacyColors.darkBlue;
        case CargoTempCategory.HeatSensitive:
            return theme.legacyColors.greyBorderColor;
        case CargoTempCategory.HeatedCooled:
            return theme.legacyColors.orangeBorderColor;
        default:
            return theme.legacyColors.lightBlue;
    }
};

export const Category = styled.div<CategoryProps>`
    padding: 0px 4px;
    border-radius: 3px;
    font-size: 0.8rem;
    height: 22px;

    .status-icon {
        border-radius: 50%;
        color: #fff;
        width: 10px;
        height: 10px;
        padding: 2px;
        font-size: 8px;
        margin-right: 5px;
        display: inline-block;
        background: ${(props) => getCategoryColor(props.categoryType)};
    }
`;

export const AlternatingRow = styled.div`
    padding: 5px 0;
    border-bottom: 1px solid #ddd;
`;

type CargoTemperatureRowProps = {
    numberOfTimesToReport: number;
};

export const CargoTemperatureConfigRow = styled.div<CargoTemperatureRowProps>`
    ${(props) => props.theme.inlineGridWrapper}
    justify-items: baseline;
    margin-left: 5px;

    grid-template-columns: 2rem 9rem 18rem 8rem 10rem;
    @media only screen and (max-width: 1440px) {
        grid-template-columns: 2rem 6rem 14rem 8rem 10rem;
    }

    &.is-header {
        font-size: 0.8rem;
        font-weight: 500;
        margin: 5px 0 0 0;
        padding-left: 5px;
        display: grid;
        background-color: #f4f4f4;
        border-bottom: 2px solid ${theme.legacyColors.headingColor};
        color: #00447e;
    }

    button {
        align-self: baseline;
    }
`;

export const InputFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InputFieldsRow = styled.div`
    ${(props) => props.theme.inlineGridWrapper}
    grid-template-columns: 11rem 5rem;
    justify-items: baseline;
`;

export const InputFieldsString = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

// Questionnaire form styles
export const InhibitorFormWrapper = styled.div`
    padding: 10px 20px;
    width: 100%;
`;

export const FormRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    width: 100%;
`;

export const FormLabel = styled.label`
    text-align: left;
    font-weight: normal;
    color: #333;
    flex: 0 0 45%;
    padding-right: 15px;
`;

type InhibitorButtonProps = {
    questionnaireCompleted: boolean;
};

export const InhibitorButton = styled(MainButton)<InhibitorButtonProps>`
    background-color: ${(props) => (props.questionnaireCompleted ? theme.colors.background.white : theme.colors.background.orange)};
`;

// Effectiveness entries styles
export const EffectivenessEntriesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 100%;
`;

export const EffectivenessEntryRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    flex-wrap: wrap;
`;

export const EffectivenessEntryInputs = styled.div`
    display: flex;
    gap: 10px;
    flex: 1;
    min-width: 0; /* Allows flex items to shrink below content size */
    flex-wrap: wrap;
`;

export const EntryDivider = styled.hr`
    width: 100%;
    border: none;
    border-top: 1px solid #ddd;
    margin: 5px 0;
`;

export const ActionButton = styled(MainButton)`
    background-color: ${(props) => props.theme.colors.primary};
    &:hover {
        background-color: ${(props) => props.theme.colors.primaryDark};
    }
    &:disabled {
        background-color: ${(props) => props.theme.colors.disabled};
        cursor: not-allowed;
    }
`;

export const FlexAutoContainer = styled.div`
    flex: 1 1 auto;
`;
